<template>
<div>
  <div class="filetitle" v-if="showbar">
    <div>
      <i class="el-icon-tickets" style="padding:0 5px 0 0;"></i>{{ item.FILENAME }}
      <el-link v-if="item.paperviewurl" :href="item.paperviewurl" type="success" target="_blank">查重报告</el-link>
      <el-link v-if="item.paperviewurlxn" :href="item.paperviewurlxn" type="success" target="_blank" style="padding-left: 8px;">查重报告(校内)</el-link>
    </div>
    <div>
      <slot name="editbar"></slot>
    </div>
  </div> 
  <!--<pdf v-if="getext(item.FILEPATH) == 'pdf'" :src="HostUrl + item.FILEPATH" :style="'width:100%;height:' + hh2 + 'px;'"></pdf>-->
  
  <!-- <iframe v-if="getext(item.FILEPATH) == 'pdf'" :src="getpdf(item.FILEPATH)" :style="'width:100%;height:' + hh2 + 'px;'"></iframe> -->
  <embed v-if="getext(item.FILEPATH) == 'pdf'" type="application/pdf"  :src="getpdf(item.FILEPATH)" :style="'width:100%;height:' + hh2 + 'px;'">
  <iframe v-else-if="getext(item.FILEPATH) == 'docx'" :src="getoffice(item.FILEPATH)"
   :style="'width:100%;height:' + hh2 + 'px;'"></iframe>
  <iframe v-else-if="getext(item.FILEPATH) == 'xlsx'" :src="getoffice(item.FILEPATH)"
   :style="'width:100%;height:' + hh2 + 'px;'"></iframe>
   <iframe v-else-if="getext(item.FILEPATH) == 'mp4'" :src="
        HostUrl + '/playflv/' + encodeURIComponent(item.FILEPATH)" :style="'width:100%;height:' + hh2 + 'px;'"></iframe>
  <iframe v-else-if="getext(item.FILEPATH) == 'flv'" :src="
        HostUrl + '/playflv/' + encodeURIComponent(item.FILEPATH) + '/' + hh3
      " :style="'width:100%;height:' + hh2 + 'px;'"></iframe>
  <audio v-else-if="getext(item.FILEPATH) == 'mp3'" :src="HostUrl + item.FILEPATH" controls="controls" :style="'width:100%;'"></audio>
  <a v-else-if="getext(item.FILEPATH) == 'zip'" :href="HostUrl + item.FILEPATH">
    <Icon size="40" type="md-archive" />点击下载
  </a>
  <a v-else-if="getext(item.FILEPATH) == 'rar'" :href="HostUrl + item.FILEPATH">
    <Icon size="40" type="md-archive" />点击下载
  </a>
  <img v-else :src="HostUrl + item.FILEPATH" :style="'width:100%;'" />
</div>
</template>

<script>
// import pdf from 'vue-pdf'
export default {
  // components: {
  //   pdf
  // },
  props: {
    item: {
      type: Object,
      default: {
        FILEPATH: ""
      },
    },
    showbar:{
      type:Boolean,
      default:true
    },
    hh: {
      type: Number,
      default: 500,
    }
  },
  watch: {
    item(to, from) {

    },
    showbar(to,from){

    },
    hh(to, from) {
      this.hh2 = to - 46;
      this.hh3 = to - 46;
    }
  },
  data() {
    return {
      hh2: 480,
      hh3: 450,
    }
  },
  mounted() {
    this.hh2 = this.hh - 46;
    this.hh3 = this.hh - 46;
  },
  methods: {
    getoffice:function(fileurl){
      //return http://127.0.0.1:8012/picturesPreview?urls='+encodeURIComponent(fileUrl)
      //'https://view.officeapps.live.com/op/view.aspx?src='
      //let host =  "http://"+window.location.host;
      let url = this.HostUrl + '/openoffice/'+encodeURIComponent(fileurl);
      return url;
    },
    getpdf:function(fileurl){
      //let url = this.HostUrl + '/pdfjs/web/viewer.html?file='+encodeURIComponent(fileurl);
      let url = this.HostUrl +fileurl;
      return url;
    },
    getext: function (filename) {
      if(!filename)
        return "jpg";
      var index1 = filename.lastIndexOf(".");
      var index2 = filename.length;
      var postf = filename.substring(index1 + 1, index2).toLowerCase(); //后缀名
      //alert(postf);
      return postf;
    },
  },
};
</script>

<style>
.filetitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  height: 35px;
  background-color: #fff;
  font-size: 15px;
  border-bottom: 1px solid #ccc;
}

iframe {
  border: 0px solid #ccc;
}
</style>
